import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const SpotprisImorgon = lazy(() => import("@/pages/spotpris/SpotprisImorgon"));

export const Route = createFileRoute("/spotpris/imorgon")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => seoHead("/spotpris/imorgon", { description: "Se morgondagens spotpris timme för timme i SE1, SE2, SE3 och SE4. Priserna publiceras cirka kl 13:30–14:00 från Nord Pool." }),
  component: () => <SpotprisImorgon />,
});
